export type PricePerProps = {
  price: string;
  pricePer: 'GB' | 'IP' | 'ww1K-req' | 'month' | 'proxy'; // ww and - is there because strapi doesn't allow spaces in keys and first character can't be a number
  prefixText?: string;
};

export function PricePer({ price, pricePer, prefixText }: PricePerProps) {
  const formattedPricePer = pricePer?.replaceAll('-', ' ').replaceAll('ww', '');

  return (
    <div className='flex items-center gap-1'>
      <span className='text-neutral-N40 text-body-s'>
        {prefixText ?? 'from'}
      </span>
      <span className='text-neutral-N00'>${price}</span>
      <span className='text-neutral-N40 text-body-s'>/{formattedPricePer}</span>
    </div>
  );
}
